import { GhostAPI } from '@tryghost/content-api';
import React, { memo } from 'react';
import withContentApi from '../hoc/withContentApi';
import HeaderMeta from '../components/header-meta';
import HeroBanner from '../components/homepage/hero-banner';
import ProgramSection from '../components/homepage/program';
import SharedInformationSection from '../components/homepage/shared-information';
import RequirementsSection from '../components/homepage/requirements';
import InquiryFormSection from '../components/homepage/inquiry-form';

interface IProps {
  api?: GhostAPI;
};

const HomePage: React.FC<IProps> = ({ api }) => {
  return (
    <>
      <HeaderMeta />
      <div className='relative antialiased'>
        <HeroBanner />
        <ProgramSection />
        <SharedInformationSection />
        <RequirementsSection />
        <InquiryFormSection />
        <div className='px-0 lg:px-16 xl:max-w-container xl:px-0 mx-auto w-full'>
        </div>
      </div>
    </>
  )
};

export default memo(withContentApi<IProps>(HomePage));
